import { render, staticRenderFns } from "./prodectDialog.vue?vue&type=template&id=4c11ab40"
import script from "./prodectDialog.vue?vue&type=script&lang=js"
export * from "./prodectDialog.vue?vue&type=script&lang=js"
import style0 from "./prodectDialog.vue?vue&type=style&index=0&id=4c11ab40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports